import React from "react"
import PropTypes from "prop-types"
import ClassNames from "classnames"
import Autosuggest from "react-autosuggest"
import InputStyles from "./../inputs.less"
import Styles from "./autosuggest-input.less"
import ValidationMixin from "@cirrus/legacy/app-components/validations/validation-mixin/index.jsx"
import createReactClass from "create-react-class"

var SuggestionInput = createReactClass({
  propTypes: {
    inputValue: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onInputChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    placeholder: PropTypes.string,
    tabIndex: PropTypes.number,
    autoFocus: PropTypes.bool,
    className: PropTypes.string,
    getSuggestionValue: PropTypes.func.isRequired,
    renderSuggestion: PropTypes.func,
    onBlur: PropTypes.func,
    isNotValid: PropTypes.bool,
    inputStyle: PropTypes.object,
    multiSection: PropTypes.bool,
    renderSectionTitle: PropTypes.func,
    getSectionSuggestions: PropTypes.func,
    suggestions: PropTypes.array.isRequired,
    onSuggestionsUpdateRequested: PropTypes.func.isRequired,
    shouldRenderSuggestions: PropTypes.bool,
    renderSuggestionsContainer: PropTypes.func,
    onSuggestionsClearRequested: PropTypes.func,
  },
  getDefaultProps() {
    return {
      renderSuggestion: renderSuggestion,
    }
  },
  onSuggestionSelected(event, { suggestion }) {
    this.props.onChange && this.props.onChange(event, suggestion)
  },
  onChange(event, { newValue }) {
    this.props.onInputChange && this.props.onInputChange(event, newValue)
  },
  shouldRenderSuggestions(value) {
    return !!value || this.props.shouldRenderSuggestions
  },
  getProps() {
    var value = this.props.inputValue
    return {
      placeholder: this.props.placeholder,
      disabled: this.props.disabled,
      value,
      onChange: this.onChange,
      style: this.props.inputStyle,
    }
  },
  getTheme() {
    var theme = returnTheme()
    theme.container = ClassNames(
      theme.container,
      {
        disabled: this.props.disabled,
      },
      this.props.className,
    )
    theme.input = ClassNames(theme.input, { notValid: this.props.isNotValid })
    return theme
  },
  render() {
    return (
      <Autosuggest
        theme={this.getTheme()}
        suggestions={this.props.suggestions}
        onSuggestionsFetchRequested={this.props.onSuggestionsUpdateRequested}
        onSuggestionSelected={this.onSuggestionSelected}
        getSuggestionValue={this.props.getSuggestionValue}
        renderSuggestion={this.props.renderSuggestion}
        inputProps={this.getProps()}
        tabIndex={this.props.tabIndex}
        autoFocus={this.props.autoFocus}
        onBlur={this.props.onBlur}
        multiSection={this.props.multiSection}
        renderSectionTitle={this.props.renderSectionTitle}
        getSectionSuggestions={this.props.getSectionSuggestions}
        shouldRenderSuggestions={this.shouldRenderSuggestions}
        renderSuggestionsContainer={this.props.renderSuggestionsContainer}
        onSuggestionsClearRequested={this.props.onSuggestionsClearRequested}
      />
    )
  },
})

export default ValidationMixin(SuggestionInput)

function returnTheme() {
  return {
    container: Styles.container,
    containerOpen: Styles.containerOpen,
    input: InputStyles.input,
    suggestionsContainer: Styles.suggestionContainer,
    suggestion: Styles.suggestion,
    suggestionHighlighted: Styles.suggestionHighlighted,
    sectionContainer: Styles.sectionContainer,
    sectionTitle: Styles.sectionTitle,
    suggestionsList: Styles.suggestionsList,
  }
}

function renderSuggestion(suggestion) {
  return <span>{suggestion.name}</span>
}
